import * as React from 'react';
import Spin from 'antd/lib/spin';
import Select, { ModeOption } from 'antd/lib/select';
import { KeyLabel } from 'src/Library/Types';
import { fetchAllTeams } from 'src/api/teams';
import { isValidArray } from 'src/Library/Helper';

interface User {
  id: string,
  name: string,
};
interface KeyLabelUsers extends KeyLabel {
  users: User[];
};
interface IProps {
  mode?: ModeOption;
  style?: any;
  placeholder?: string;
  className?: string;
  value?: string;
  onChange: (val) => void;
  disabled?: boolean;
  apiOptions?: TeamApiParams;
  selectedTeamName?: string;
  changeUserOptions: (users: User[]) => void;
}

interface TeamApiParams {
}

const TeamSelect = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    apiOptions,
    placeholder,
    selectedTeamName,
    changeUserOptions,
  } = props;

  const [teams, setTeams] = React.useState<KeyLabelUsers[]>([]);
  const [searching, setSearching] = React.useState<boolean>(false);

  React.useEffect(() => {
    getTeams();
  }, []);
  React.useEffect(() => {
    const item = teams.find(item => item.key === value);
    item && changeUserOptions(item.users);
  }, [value]);

  function getKeyLabelUsersFromArray(inputArray): KeyLabelUsers[] {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map(item => ({
      key: item.id,
      label: item.name,
      users: item.users,
    }));
  }

  const getTeams = async () => {
    setSearching(true);
    const organisationId = window.localStorage.getItem('organisationId');
    const response = await fetchAllTeams({ adminRestriction: true, getAllTeams: true });
    // parent orgs can see all shared teams, hence the filter
    const filteredTeams = response?.data.filter(team => team.organisation_id === organisationId);
    setTeams(getKeyLabelUsersFromArray(filteredTeams));
    setSearching(false);
  };

  const dropdownRender = (menu) => {
    if (searching) {
      return <Spin
        style={{
          marginLeft: '45%',
          marginTop: '20%',
        }}
      />;
    }
    return menu;
  };

  const renderTeamOptions = () => {
    return teams?.map((team: KeyLabelUsers) => <Select.Option
      key={team.key}
      data-value={team.users}
    >
      {team.label}
    </Select.Option>) || [];
  };

  const getValue = () => {
    const selectedTeam = teams.find(item => item.key === value);
    return selectedTeam?.key || selectedTeamName;
  }

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    value={getValue()}
    onChange={(val) => onChange(val)}
    disabled={disabled}
    className={className}
    mode={mode || 'default'}
    filterOption={(inputValue, option) => {
      if (!inputValue) return true;
      const optionval = String(option.props?.children)?.trim().toLowerCase();
      return optionval.includes(inputValue.trim().toLowerCase());
    }}
    dropdownRender={dropdownRender}
    placeholder={placeholder || 'Select Team'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderTeamOptions()}
  </Select>;
};

export default TeamSelect;
